<template>
  <modal :name="nome" height="auto" width="640" :scrollable="true" :clickToClose="false" @opened="onOpened" @closed="onClosed">
    <CloseModal :close="closeModal"/>
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="cd-title">Selecionar campo</div>

        <div class="cd-search-wrapper">
          <fa-icon icon="search" class="cd-search-icon" />
          <input
            ref="searchInput"
            type="text"
            class="cd-search-input"
            placeholder="Buscar por nome ou identificador..."
            v-model="busca"
            @keydown.down.prevent="navegarParaBaixo"
            @keydown.up.prevent="navegarParaCima"
            @keydown.enter.prevent="selecionarAtivo"
            @keydown.esc="closeModal"
          />
          <span v-if="busca" class="cd-search-clear" @click="busca = ''">
            <fa-icon icon="times" />
          </span>
        </div>

        <div class="cd-counter">
          {{ totalFiltrado }} de {{ totalCampos }} campo(s)
        </div>

        <div class="cd-body">
          <div v-if="totalFiltrado === 0" class="cd-empty">
            <fa-icon icon="search" class="cd-empty-icon" />
            <div class="cd-empty-text">Nenhum campo encontrado</div>
            <div class="cd-empty-desc">Tente buscar com termos diferentes.</div>
          </div>

          <div v-for="(grupo, nomeGrupo) in gruposFiltrados" :key="nomeGrupo" class="cd-group">
            <div
              class="cd-group-header"
              @click="toggleGrupo(nomeGrupo)"
            >
              <fa-icon
                :icon="gruposAbertos[nomeGrupo] !== false ? 'chevron-down' : 'chevron-right'"
                class="cd-group-chevron"
              />
              <span class="cd-group-label">{{ nomeGrupo }}</span>
              <span class="cd-group-count">{{ grupo.length }}</span>
            </div>

            <div v-show="gruposAbertos[nomeGrupo]" class="cd-group-items">
              <div
                v-for="campo in grupo"
                :key="campo.id"
                class="cd-item"
                :class="{ 'cd-item--active': campo.globalIndex === indiceFocado }"
                :ref="'item-' + campo.globalIndex"
                @click="onSelectCampo(campo.id)"
                @mouseenter="indiceFocado = campo.globalIndex"
              >
                <div class="cd-item-info">
                  <div class="cd-item-label" v-html="destacar(campo.label)"></div>
                  <code class="cd-item-id" v-html="destacar(campo.id)"></code>
                </div>
                <fa-icon icon="arrow-right" class="cd-item-arrow" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import CloseModal from "../../../components/CloseModal";

export default {
  name: "CamposDisponiveis",
  props: ['campos', 'nome', 'onSelect'],
  components: { CloseModal },
  data() {
    return {
      busca: '',
      indiceFocado: -1,
      gruposAbertos: {},
    }
  },
  computed: {
    camposArray() {
      if (!this.campos) return [];
      return Object.entries(this.campos).map(([id, label]) => ({ id, label }));
    },
    camposAgrupados() {
      const grupos = {};
      this.camposArray.forEach(campo => {
        const nomeGrupo = this.detectarGrupo(campo.id);
        if (!grupos[nomeGrupo]) grupos[nomeGrupo] = [];
        grupos[nomeGrupo].push(campo);
      });
      return grupos;
    },
    gruposFiltrados() {
      const termo = this.busca.toLowerCase().trim();
      const resultado = {};
      let globalIndex = 0;

      const gruposOrdenados = Object.keys(this.camposAgrupados).sort((a, b) => {
        if (a === 'Campos') return -1;
        if (b === 'Campos') return 1;
        if (a === 'Campos Adicionais') return 1;
        if (b === 'Campos Adicionais') return -1;
        return a.localeCompare(b);
      });

      gruposOrdenados.forEach(nomeGrupo => {
        const campos = this.camposAgrupados[nomeGrupo];
        const filtrados = termo
          ? campos.filter(c =>
              c.label.toLowerCase().includes(termo) ||
              c.id.toLowerCase().includes(termo)
            )
          : campos;

        if (filtrados.length > 0) {
          resultado[nomeGrupo] = filtrados.map(c => ({
            ...c,
            globalIndex: globalIndex++
          }));
        }
      });

      return resultado;
    },
    totalFiltrado() {
      return Object.values(this.gruposFiltrados).reduce((s, g) => s + g.length, 0);
    },
    totalCampos() {
      return this.camposArray.length;
    },
    todosVisiveis() {
      const arr = [];
      Object.values(this.gruposFiltrados).forEach(grupo => {
        grupo.forEach(campo => arr.push(campo));
      });
      return arr;
    },
  },
  methods: {
    detectarGrupo(id) {
      if (id.startsWith('campoAdicional.') || id.startsWith('camposAdicionais.')) {
        return 'Campos Adicionais';
      }

      const prefixos = {
        'valor': 'Valores',
        'percentual': 'Valores',
        'perc_': 'Valores',
        'data': 'Datas',
        'dthora': 'Datas',
        'latitude': 'Localiza\u00e7\u00e3o',
        'longitude': 'Localiza\u00e7\u00e3o',
        'utm_': 'Rastreamento',
        'observacao': 'Observa\u00e7\u00f5es',
        'sac_': 'SAC',
      };

      for (const [prefixo, grupo] of Object.entries(prefixos)) {
        if (id.startsWith(prefixo)) return grupo;
      }

      return 'Campos';
    },
    toggleGrupo(nome) {
      this.$set(this.gruposAbertos, nome, !this.gruposAbertos[nome]);
    },
    onOpened() {
      this.busca = '';
      this.indiceFocado = -1;
      this.$nextTick(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus();
        }
      });
    },
    onClosed() {
      this.busca = '';
      this.indiceFocado = -1;
    },
    closeModal() {
      this.$modal.hide(this.nome);
    },
    onSelectCampo(valor) {
      this.$modal.hide(this.nome);
      this.onSelect(valor);
    },
    navegarParaBaixo() {
      if (this.totalFiltrado === 0) return;
      this.indiceFocado = (this.indiceFocado + 1) % this.totalFiltrado;
      this.scrollToFocado();
    },
    navegarParaCima() {
      if (this.totalFiltrado === 0) return;
      this.indiceFocado = this.indiceFocado <= 0 ? this.totalFiltrado - 1 : this.indiceFocado - 1;
      this.scrollToFocado();
    },
    selecionarAtivo() {
      const campo = this.todosVisiveis.find(c => c.globalIndex === this.indiceFocado);
      if (campo) {
        this.onSelectCampo(campo.id);
      }
    },
    scrollToFocado() {
      this.$nextTick(() => {
        const refKey = 'item-' + this.indiceFocado;
        const el = this.$refs[refKey];
        if (el && el[0]) {
          el[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });
    },
    destacar(texto) {
      const termo = this.busca.trim();
      if (!termo) return this.escapeHtml(texto);
      const escaped = this.escapeHtml(texto);
      const termoEscaped = this.escapeRegex(this.escapeHtml(termo));
      const regex = new RegExp(`(${termoEscaped})`, 'gi');
      return escaped.replace(regex, '<mark class="cd-highlight">$1</mark>');
    },
    escapeHtml(text) {
      const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
      return String(text).replace(/[&<>"']/g, m => map[m]);
    },
    escapeRegex(text) {
      return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
  },
  watch: {
    busca(val) {
      this.indiceFocado = -1;
      if (val.trim()) {
        Object.keys(this.gruposFiltrados).forEach(nome => {
          this.$set(this.gruposAbertos, nome, true);
        });
      }
    }
  }
}
</script>

<style scoped>
/* Title */
.cd-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d2939;
  margin-bottom: 12px;
}

/* Search */
.cd-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.cd-search-icon {
  position: absolute;
  left: 12px;
  color: #98a2b3;
  font-size: 13px;
  pointer-events: none;
}

.cd-search-input {
  width: 100%;
  padding: 9px 36px 9px 36px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  font-size: 13px;
  color: #344054;
  background: #fff;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.cd-search-input:focus {
  border-color: #3a3e81;
  box-shadow: 0 0 0 3px rgba(58, 62, 129, 0.1);
}

.cd-search-input::placeholder {
  color: #98a2b3;
}

.cd-search-clear {
  position: absolute;
  right: 10px;
  color: #98a2b3;
  cursor: pointer;
  font-size: 12px;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.15s;
}

.cd-search-clear:hover {
  color: #667085;
  background: #f2f4f7;
}

.cd-counter {
  font-size: 11px;
  color: #98a2b3;
  margin-top: 8px;
  margin-bottom: 12px;
}

/* Body - lista de campos */
.cd-body {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  overflow: hidden;
  max-height: 400px;
  overflow-y: auto;
}

/* Empty state */
.cd-empty {
  text-align: center;
  padding: 40px 20px;
}

.cd-empty-icon {
  font-size: 24px;
  color: #d0d5dd;
  margin-bottom: 10px;
}

.cd-empty-text {
  font-weight: 600;
  font-size: 14px;
  color: #344054;
}

.cd-empty-desc {
  font-size: 12px;
  color: #98a2b3;
  margin-top: 4px;
}

/* Groups */
.cd-group + .cd-group {
  border-top: 1px solid #f2f4f7;
}

.cd-group-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #f8f9fa;
  cursor: pointer;
  user-select: none;
  transition: background 0.1s;
}

.cd-group-header:hover {
  background: #f2f4f7;
}

.cd-group-chevron {
  font-size: 10px;
  color: #98a2b3;
  width: 12px;
  flex-shrink: 0;
}

.cd-group-label {
  font-size: 11px;
  font-weight: 700;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex: 1;
}

.cd-group-count {
  font-size: 10px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 4px;
  border: 1px solid #d0d5dd;
  color: #667085;
  background: #fff;
}

/* Items */
.cd-group-items {
  padding: 2px 0;
}

.cd-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 7px 16px 7px 36px;
  cursor: pointer;
  transition: background 0.1s;
}

.cd-item:hover,
.cd-item--active {
  background: #f2f2f8;
}

.cd-item--active {
  background: #eceaf3;
}

.cd-item-info {
  flex: 1;
  min-width: 0;
}

.cd-item-label {
  font-size: 13px;
  font-weight: 500;
  color: #344054;
  line-height: 1.3;
}

.cd-item-id {
  font-size: 11px;
  color: #98a2b3;
  background: none;
  padding: 0;
  display: block;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cd-item--active .cd-item-label {
  color: #3a3e81;
  font-weight: 600;
}

.cd-item--active .cd-item-id {
  color: #6b6fa6;
}

.cd-item-arrow {
  font-size: 10px;
  color: transparent;
  flex-shrink: 0;
  transition: color 0.1s, transform 0.1s;
}

.cd-item:hover .cd-item-arrow,
.cd-item--active .cd-item-arrow {
  color: #3a3e81;
}

.cd-item--active .cd-item-arrow {
  transform: translateX(2px);
}

/* Search highlight */
.cd-highlight {
  background: #fef3c7;
  color: #92400e;
  border-radius: 2px;
  padding: 0 1px;
}
</style>
